import {ReactComponent as MoneyIcon} from './money.svg'

function Money() {
  return <MoneyIcon />
}

export default Money
